import { render, staticRenderFns } from "./NotificationPricesOffers.vue?vue&type=template&id=266e5fe2&scoped=true"
import script from "./NotificationPricesOffers.vue?vue&type=script&lang=js"
export * from "./NotificationPricesOffers.vue?vue&type=script&lang=js"
import style0 from "./NotificationPricesOffers.vue?vue&type=style&index=0&id=266e5fe2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266e5fe2",
  null
  
)

export default component.exports